/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*
*/

import { HttpParams } from "@angular/common/http";
import { AboChart } from "@src/app/modules/agent/agent-dashboard-page/AboChart";

export class AboMyOmcChart extends AboChart {
    title = "My Busiest OMCs by Action";
    dataParams = new HttpParams().set('week', 0).set('show', 'myomcs');
}
